import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { defaultAxiosInstance } from "services/client"
import { ResponseData } from "services/common"

export const defaultUrlDev = `${process.env.REACT_APP_BASE_API_URL || ""}`

// -------- import listing table data show APIs  [import listing screen ]----------
export interface ListingDataType {
  isReviewPending: boolean
  imageLink: string
  airbnbImageUrl: string
  propertyName: string
  state: string
  city: string
  country: string
  noOfBeds: number
  noOfBaths: number
  photosCount: number
  airbnbUrl: string
  airbnbLastSyncDt: number
  status: "LIVE" | "INACTIVE" | "PENDING" | "UNPUBLISHED"
  propertyId: string
  pmcId: string
  unitId: string
  _id: string
  pmsSystem: string
}

export interface GetListingData {
  content: ListingDataType[]
  pageable: {
    sort: {
      empty: boolean
      sorted: boolean
      unsorted: boolean
    }
    offset: number
    pageNumber: number
    pageSize: number
    paged: boolean
    unpaged: boolean
  }
  last: boolean
  totalPages: number
  totalElements: number
  number: number
  sort: {
    empty: boolean
    sorted: boolean
    unsorted: boolean
  }
  size: number
  first: boolean
  numberOfElements: number
  empty: boolean
}

export interface RboImportListingResponseData extends ResponseData {
  data: GetListingData
}

export interface RboImportListingResponse extends AxiosResponse {
  data: RboImportListingResponseData
}

export interface RboImportListingRequestData {
  pmcId: string
  keyword: string
  pageNo: string
  noOfRecords: string
  sortDirection: string
  sortBy: string
  searchFirstById: string | null
  searchByStatus: string | null
}

export interface RboImportListingRequest extends Partial<AxiosRequestConfig> {
  params: RboImportListingRequestData
}

export function rboImportListingApi(
  { params }: RboImportListingRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    params,
    method: "get",
    url: `${defaultUrlDev}/rbo/all`,
  }) as Promise<RboImportListingResponse>
}

// -------- refresh & sync properties data apis  [import listing screen ]----------

export interface RefreshRboPropertiesResponse extends AxiosResponse {
  data: {
    message: string
  }
}
export interface RefreshRboPropertiesRequest
  extends Partial<AxiosRequestConfig> {
  params: {
    pmcId: string
  }
}

export function refreshRboPropertiesApi(
  { params }: RefreshRboPropertiesRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    params,
    method: "get",
    url: `${defaultUrlDev}/properties/refresh-rbo-properties`,
  }) as Promise<RefreshRboPropertiesResponse>
}

// -------- user get property status [import listing screen ] ----------

export interface UserGetPropertiesStatusType {
  failedCount: number | null
  propertyCount: number | null
  totalCount: number | null
}

export interface UserGetPropertiesStatusResponseData extends AxiosResponse {
  data: UserGetPropertiesStatusType
}
export interface UserGetPropertiesStatusResponse extends AxiosResponse {
  data: UserGetPropertiesStatusResponseData
}

export interface UserGetPropertiesStatusRequest
  extends Partial<AxiosRequestConfig> {
  params: {
    pmcId: string
    hostProfileId: number
  }
}

export function userGetPropertiesStatusApi(
  { params }: UserGetPropertiesStatusRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    params,
    method: "get",
    url: `${defaultUrlDev}/user/get-property-status`,
  }) as Promise<UserGetPropertiesStatusResponse>
}

// ---------- publish multiple listing for import listing RBO ---------- //

export interface PublishResponseData extends ResponseData {
  total_listing_count: number
  total_publish_count: number
  total_unpublish_count: number
}

export interface PublishMultiplePropertyForRBOResponseData
  extends ResponseData {
  data: PublishResponseData
}

export interface PublishMultiplePropertyForRBOResponse extends AxiosResponse {
  data: PublishMultiplePropertyForRBOResponseData
}

export interface PublishMultiplePropertyForRBORequestData {
  pmcId: string
  eventType: string
  isAutoPublish: boolean
  allUpdate: boolean
  pmsUnitIds: string[]
}
export interface PublishMultiplePropertyForRBORequest
  extends Partial<AxiosRequestConfig> {
  params: PublishMultiplePropertyForRBORequestData
}

const defaultPublishMultiplePropertyURL = `${
  process.env.REACT_APP_BASE_API_URL || ""
}/properties/rbo-publish-properties`

export function publishMultiplePropertyForRBOApi(
  {
    params,
    method = "post",
    url = defaultPublishMultiplePropertyURL,
    ...config
  }: PublishMultiplePropertyForRBORequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<PublishMultiplePropertyForRBOResponse> {
  return axiosInstance({
    method,
    url: `${url}`,
    data: params,
    ...config,
  }) as Promise<PublishMultiplePropertyForRBOResponse>
}
